import React, { useState, useEffect } from 'react';
// import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
// import { FaQuoteRight } from 'react-icons/fa';
import data from './reviewData';
import './ourReviews.css'
//importing icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteRight } from '@fortawesome/free-solid-svg-icons';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

function OurReviews() {
  const [people, setPeople] = useState(data);
  const [index, setIndex] = React.useState(0);

  useEffect(() => {
    const lastIndex = people.length - 1;
    if (index < 0) {
      setIndex(lastIndex);
    }
    if (index > lastIndex) {
      setIndex(0);
    }
  }, [index, people]);

  useEffect(() => {
    let slider = setInterval(() => {
      setIndex(index + 1);
    }, 5000);
    return () => {
      clearInterval(slider);
    };
  }, [index]);

  return (
    <div className="container__one">
      <section className="section">
        <div className="title">
          <span>WHAT OUR CUSTOMERS SAY</span>
        </div>
        <div className="section-center">
          {people.map((person, personIndex) => {
            const { id, image, name, title, quote } = person;

            let position = 'nextSlide';
            if (personIndex === index) {
              position = 'activeSlide';
            }
            if (
              personIndex === index - 1 ||
              (index === 0 && personIndex === people.length - 1)
            ) {
              position = 'lastSlide';
            }

            return (
              <article className={position} key={id}>
                <img src={image} alt={name} className="person-img" />
                <h4>{name}</h4>
                <p className="person__title">{title}</p>
                <p className="text">{quote}</p>
                {/* <FaQuoteRight className="icon" /> */}
                {/* <FontAwesomeIcon
                  icon={faQuoteRight}
                  className="icon"
                /> */}
              </article>
            );
          })}
          <button className="prev" onClick={() => setIndex(index - 1)}>
            {/* <FiChevronLeft /> */}
            <FontAwesomeIcon
              icon={faChevronLeft}
            />
          </button>
          <button className="next" onClick={() => setIndex(index + 1)}>
            {/* <FiChevronRight /> */}
            <FontAwesomeIcon
              icon={faChevronRight}
            />
          </button>
        </div>
      </section>
    </div>
  );
}

export default OurReviews;
